import { LanguagesEnum } from 'types/index'

export type Ticket = {
  _id: string
  code: string
  email: string
  name: string
  surname: string
  agency?: string
  description: string
  createdAt: string
  status: TicketStatusEnum
  languageArea: LanguagesEnum
}

export enum TicketStatusEnum {
  NEW = 'new',
  IN_PROGRESS = 'inProgress',
  CLOSED = 'closed',
  REFUSED = 'refused',
  CLIENT_CLOSED = 'clientClosed',
}
